<div class="loadingSmall">
  <p>Carregando informações, aguarde...</p>
  <img src="assets/img/loading1.gif">
</div>